// `Array[@@species]` getter
// https://tc39.github.io/ecma262/#sec-get-array-@@species
require('../internals/set-species')('Array');